<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 页面卡片 -->
    <div class="page-card">
      <!-- 页面头部 -->
      <div class="page-card__header">
        添加展商
      </div>
      <!-- 表单内容 -->
      <div class="page-card__body">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
          <el-form-item
            prop="username"
            label="用户名："
            style="margin-top: 20px"
          >
            <el-input
              placeholder="填入用户名"
              v-model="form.username"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" label="密码：" style="margin-top: 20px">
            <el-input
              placeholder="填入密码"
              v-model="form.password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="name" label="公司名称：" style="margin-top: 20px">
            <el-input placeholder="填入公司名称" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item prop="booth" label="展位号：" style="margin-top: 20px">
            <el-input placeholder="填入展位号" v-model="form.booth"></el-input>
          </el-form-item>
          <el-row style="margin-top: 30px; text-align: center">
            <el-button
              round
              size="small"
              @click="onSubmit('form')"
              type="primary"
            >
              确定添加</el-button
            >
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "addCompany",
  data() {
    // 密码校验规则
    let validateCheckPasswword = (rule, value, callback) => {
      let reg = /^[0-9A-Za-z]{6,16}$/;
      setTimeout(() => {
        if (!value) {
          return callback(new Error("密码不能为空"));
        } else {
          if (!reg.test(value)) {
            callback(new Error("密码必须由6-16位数字或密码组成"));
          } else {
            callback();
          }
        }
      }, 500);
    };
    return {
      form: {
        name: "",
        booth: "",
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请填写公司名", trigger: "blur" },
        ],
        password: [
          {
            validator: validateCheckPasswword,
            required: true,
            trigger: "blur",
          },
        ],
        booth: [{ required: true, message: "请填写展位号", trigger: "blur" }],

        name: [{ required: true, message: "请填写用户名", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 提交添加展商表单
    onSubmit(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let url = this.baseUrl + "/admin/users/";
          api
            .postData(url, {
              username: this.form.username,
              password: this.form.password,
              name: this.form.name,
              booth: this.form.booth,
            })
            .then((res) => {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.$router.push({ name: "admin_companyList" });
            })
            .catch((error) => {
              this.$message({
                message: error.response.data,
                type: "error",
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/addCompany.vue